module.exports = __webpack_public_path__ + "aa5fa807d2b651de7b40e9276d4d0897.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/email.svg
// module id = 1930
// module chunks = 0